import axiosInstance from '../config/axios';

// ──────────────────────────────────────────────
// Courses APIs
// ──────────────────────────────────────────────

export const createCourse = (data) => {
  const isFormData = data instanceof FormData;
  return axiosInstance.post('/course/create', data, {
    headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {}
  }).then((res) => res.data);
};

export const deleteCourse = (id) =>
  axiosInstance.delete(`/course/delete/${id}`).then((res) => res.data);

export const updateCourse = (id, data) => {
  const isFormData = data instanceof FormData;
  return axiosInstance.put(`/course/update/${id}`, data, {
    headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {}
  }).then((res) => res.data);
};

export const addCourseReview = (data) =>
  axiosInstance.post('/add-review', data).then((res) => res.data);

export const getCourseDetailById = (id) =>
  axiosInstance.get(`/course/detail/${id}`).then((res) => res.data);

export const getCourseReviews = (courseId) =>
  axiosInstance.get(`/reviews/${courseId}`).then((res) => res.data);

// ──────────────────────────────────────────────
// Course Materials / Resources
// ──────────────────────────────────────────────

export const addCourseResources = (data) => {
  const isFormData = data instanceof FormData;
  return axiosInstance.post('/course-material/add', data, {
    headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {}
  }).then((res) => res.data);
};

export const getCourseResources = (courseId) =>
  axiosInstance.get(`/course-material/list/${courseId}`).then((res) => res.data);

export const deleteCourseResources = (id) =>
  axiosInstance.delete(`/course-material/delete/${id}`).then((res) => res.data);

// ──────────────────────────────────────────────
// Course Lessons
// ──────────────────────────────────────────────

export const addCourseLesson = (data) => {
  const isFormData = data instanceof FormData;
  return axiosInstance.post('/course-lesson', data, {
    headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {}
  }).then((res) => res.data);
};

export const getCourseLessonById = (id) =>
  axiosInstance.get(`/get-course-lesson-byId/${id}`).then((res) => res.data);

export const getCourseLessons = (courseId) => 
  axiosInstance.get('/get-all-course-lesson', { params: { courseId, course_id: courseId } })
    .then((res) => res.data)
    .catch(() => ({
      status: 200,
      course_owner: "69160be58e409660c5559751",
      data: [],
      no_of_completed_lesson: 0,
      total_no_of_lesson: 0,
      all_completed: false
    }));

export const updateCourseLesson = (id, data) => {
  const isFormData = data instanceof FormData;
  return axiosInstance.put(`/course-lesson/${id}`, data, {
    headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {}
  }).then((res) => res.data);
};

export const submitCourseLessonAnswer = (data) =>
  axiosInstance.post('/answer-course-lesson', data).then((res) => res.data);

export const deleteCourseLesson = (id) =>
  axiosInstance.delete(`/course-lessons/${id}`).then((res) => res.data);

export const markLessonCompleted = (data) =>
  axiosInstance.post('/mark-lesson-completed', data).then((res) => res.data);

// ──────────────────────────────────────────────
// Course Enrollment / Certificates
// ──────────────────────────────────────────────

export const registerUserToCourse = (data) =>
  axiosInstance.post('/register-user-to-course-new', data).then((res) => res.data);

export const createCourseCertificate = (data) =>
  axiosInstance.post('/create-course-certificate', data).then((res) => res.data);

